"use strict";
const RX = /\[chart\s+type="(\w+)"\s+src="([^"]+)"\]/g;
const ALLOWED = ["dumbbell", "unit", "upset"];
function mountMarkup(type, src) {
  return `<div class="engagement-chart" data-controller="charts--viz" data-charts--viz-type-value="${type}" data-charts--viz-src-value="${src.replace(/"/g, "&quot;")}"><noscript>Enable JavaScript to view this chart.</noscript></div>`;
}
export function scanForShortcodes(root) {
  root.querySelectorAll(".rich-text-display").forEach((block) => {
    if (!RX.test(block.textContent)) return;
    RX.lastIndex = 0;
    block.innerHTML = block.innerHTML.replace(RX, (match, type, src) => {
      if (!ALLOWED.includes(type) || !src.startsWith("/charts/")) return match;
      return mountMarkup(type, src);
    });
  });
}
